module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app_detail clearfix p_background"
  }, [_c('h3', {
    staticClass: "all_title"
  }, [_vm._v("应用审核")]), _vm._v(" "), _c('section', {
    staticClass: "app_detail_box tb_padding container_box clearfix"
  }, [_c('div', {
    staticClass: "details_title_box clearfix"
  }, [_c('div', {
    staticClass: "photo_left inline-block"
  }, [_c('div', {
    staticClass: "photo_info",
    staticStyle: {
      "width": "160px",
      "height": "160px",
      "border-radius": "32px"
    }
  }, [_c('div', {
    staticClass: "img_default hidden"
  }), _vm._v(" "), _c('img', {
    staticClass: "img_default",
    attrs: {
      "src": _vm.logoPath,
      "id": "app_icon_first",
      "alt": ""
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "form_box",
    staticStyle: {
      "margin-left": "26px"
    }
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("版本编号：")]), _vm._v(" "), _c('span', {
    staticClass: "color_9"
  }, [_vm._v(_vm._s(_vm.tCloudAppAuditApplicationDTO.versionno))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box",
    staticStyle: {
      "margin-left": "26px"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.checkZipByAppId
    }
  }, [_vm._v("检测安装包")])])]), _vm._v(" "), _c('div', {
    staticClass: "intro_right inline-block"
  }, [_c('h4', [_vm._v(_vm._s(_vm.tCloudAppAuditApplicationDTO.appname))]), _vm._v(" "), _c('div', {
    staticClass: "right_box clearfix"
  }, [_c('section', {
    staticClass: "col-sm-6 right_box_right"
  }, [_c('p', [_c('span', {
    staticClass: "intro_title inline-block"
  }, [_vm._v("申请时间：")]), _vm._v(" "), _c('span', {
    staticClass: "intro_text inline-block"
  }, [_vm._v(_vm._s(_vm._f("time")(_vm.tCloudAppAuditApplicationDTO.publishtime)))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "intro_title inline-block"
  }, [_vm._v("应用分类：")]), _vm._v(" "), _vm._l((_vm.appTypeOptions), function(option) {
    return (_vm.appCloud.businessType == option.id) ? _c('span', {
      staticClass: "intro_text inline-block"
    }, [_vm._v(_vm._s(option.dictionaryname))]) : _vm._e()
  })], 2), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "intro_title inline-block"
  }, [_vm._v("群体范围：")]), _vm._v(" "), _c('span', {
    staticClass: "intro_text inline-block"
  }, [_vm._v(_vm._s(_vm.appCloud.tcloudAppVersion.userScope))])])]), _vm._v(" "), _c('section', {
    staticClass: "col-sm-6 right_box_right"
  }, [_c('p', [_c('span', {
    staticClass: "intro_title inline-block"
  }, [_vm._v("增值服务：")]), _vm._v(" "), _c('span', {
    staticClass: "intro_text inline-block"
  }, [_vm._v(_vm._s(_vm.appCloud.tcloudAppVersion.addserviceApis))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "intro_title inline-block"
  }, [_vm._v("部署类型：")]), _vm._v(" "), _c('span', {
    staticClass: "intro_text inline-block"
  }, [_vm._v(_vm._s(_vm.tCloudAppAuditApplicationDTO.deploytype))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "intro_title inline-block"
  }, [_vm._v("数据接口权限：")]), _vm._v(" "), _c('span', {
    staticClass: "intro_text inline-block"
  }, [_vm._v(_vm._s(_vm.appCloud.tcloudAppVersion.misdataApis))])])])]), _vm._v(" "), _c('div', {
    staticClass: "developer"
  }, [_c('p', [_c('span', {
    staticClass: "intro_title inline-block"
  }, [_vm._v("开发者：")]), _vm._v(" "), _c('span', {
    staticClass: "intro_text inline-block"
  }, [_vm._v(_vm._s(_vm.tCloudAppAuditApplicationDTO.uploaduser))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "details_presentation_box word-bw"
  }, [_c('h5', {
    staticClass: "ht5"
  }, [_vm._v("应用介绍：")]), _vm._v(" "), _c('p', {
    staticClass: "color_9"
  }, [_vm._v(_vm._s(_vm.tCloudAppAuditApplicationDTO.appcomment))])]), _vm._v(" "), _c('div', {
    staticClass: "details_presentation_box word-bw"
  }, [_c('h5', {
    staticClass: "ht5"
  }, [_vm._v("应用价格：")]), _vm._v(" "), _c('section', {
    staticClass: "add_list clearfix"
  }, [(_vm.addLists.length > 0) ? _c('table', {
    staticClass: "table table_dashed"
  }, [_c('tbody', _vm._l((_vm.addLists), function(addList, index) {
    return _c('tr', [_c('td', [_c('span', {
      staticClass: "color_6"
    }, [_vm._v("单套价格（人民币）：")]), _vm._v(" "), (!_vm.costFlag) ? _c('span', {
      staticClass: "color_9 addList_money"
    }, [_vm._v(_vm._s(addList.money) + " 元")]) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addList.money),
        expression: "addList.money"
      }],
      staticClass: "form-control width_auto form_control addList_money",
      attrs: {
        "type": "text",
        "disabled": _vm.hidsubv,
        "name": "",
        "maxlength": "12",
        "id": 'addList_money' + index
      },
      domProps: {
        "value": (addList.money)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(addList, "money", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "color_6"
    }, [_vm._v("服务期限：")]), _vm._v(" "), (!_vm.costFlag) ? _c('span', {
      staticClass: "color_9 addList_timeLimit"
    }, [_vm._v(_vm._s(addList.timeLimitValue))]) : _vm._e(), _vm._v(" "), _c('input', {
      staticClass: "addList_timeLimit",
      attrs: {
        "type": "hidden",
        "id": 'addList_timeLimit' + index
      },
      domProps: {
        "value": addList.timeLimit
      }
    }), _vm._v(" "), (_vm.costFlag) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addList.timeLimit),
        expression: "addList.timeLimit"
      }],
      staticClass: "form-control form_control",
      attrs: {
        "disabled": _vm.hidsubv
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(addList, "timeLimit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("请选择服务期限")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v("1个月")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "12"
      }
    }, [_vm._v("1年")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "9999"
      }
    }, [_vm._v("无期限")])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "color_6"
    }, [_vm._v("套数区间：")]), _vm._v(" "), (!_vm.costFlag) ? _c('span', {
      staticClass: "color_9 addList_minNum addList_maxNum"
    }, [_vm._v(_vm._s(addList.minNum) + " ~ " + _vm._s(addList.maxNum) + " 套")]) : _c('span', {
      staticClass: "suit"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addList.minNum),
        expression: "addList.minNum"
      }],
      staticClass: "form-control form_control addList_minNum",
      attrs: {
        "type": "text",
        "name": "",
        "disabled": _vm.hidsubv,
        "id": 'addList_minNum' + index,
        "maxlength": "10",
        "value": ""
      },
      domProps: {
        "value": (addList.minNum)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(addList, "minNum", $event.target.value)
        }
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t~\n\t\t\t\t\t\t\t\t"), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (addList.maxNum),
        expression: "addList.maxNum"
      }],
      staticClass: "form-control form_control addList_maxNum",
      attrs: {
        "type": "text",
        "name": "",
        "disabled": _vm.hidsubv,
        "id": 'addList_maxNum' + index,
        "maxlength": "10",
        "value": ""
      },
      domProps: {
        "value": (addList.maxNum)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(addList, "maxNum", $event.target.value)
        }
      }
    })])])])
  }), 0)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "details_presentation_box word-bw"
  }, [_c('h5', {
    staticClass: "ht5"
  }, [_vm._v("版本更新说明：")]), _vm._v(" "), _c('p', {
    staticClass: "color_9"
  }, [_vm._v(_vm._s(_vm.tCloudAppAuditApplicationDTO.versioncomment))]), _vm._v(" "), _c('div', {
    staticClass: "details_presentation_box",
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dd",
    staticStyle: {
      "margin": "10",
      "display": "none"
    },
    attrs: {
      "id": "versions"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.tCloudAppVersionList), function(listVersion) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(listVersion.appname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(listVersion.versionno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("time")(listVersion.publishtime ? listVersion.publishtime : '')))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "details_screenshot_box"
  }, [_c('h5', {
    staticClass: "ht5"
  }, [_vm._v("屏幕截图：")]), _vm._v(" "), _c('el-carousel', {
    attrs: {
      "interval": 4000,
      "type": "card",
      "height": "300px"
    }
  }, _vm._l((_vm.appCloudFiles), function(pic, index) {
    return _c('el-carousel-item', {
      key: pic.appCloudFiles
    }, [_c('div', {
      staticClass: "item"
    }, [_c('img', {
      attrs: {
        "src": pic.filePath
      }
    })])])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "details_record_box"
  }, [_c('h5', {
    staticClass: "ht5"
  }, [_vm._v("审核记录：")]), _vm._v(" "), (_vm.tCloudAppInspectList.length > 0) ? _c('section', _vm._l((_vm.tCloudAppInspectList), function(audit) {
    return _c('p', {
      staticClass: "color_9 line_block"
    }, [_c('span', {
      staticClass: "time text-space"
    }, [_vm._v(_vm._s(_vm._f("time")(audit.inputTime)))]), _vm._v(" "), _c('span', {
      staticClass: "name text-space",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": "管理员【名称v.1.0.1】"
      }
    }, [_vm._v("管理员【" + _vm._s(audit.inputUser) + " " + _vm._s(audit.versionno) + "】")]), _vm._v(" "), (audit.inspectStatus == '2') ? _c('span', {
      staticClass: "state state_not"
    }, [_vm._v("不通过")]) : _vm._e(), _vm._v(" "), (audit.inspectStatus == '1') ? _c('span', {
      staticClass: "state state_success"
    }, [_vm._v("通过")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "text text-space",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        "title": audit.inspectComment
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(audit.inspectComment) + "\n\t\t\t\t\t")])])
  }), 0) : _c('section', [_c('p', {
    staticClass: "color_9"
  }, [_vm._v("    暂无审核记录")])])]), _vm._v(" "), _c('div', {
    staticClass: "details_record_box",
    attrs: {
      "id": "review_inspect"
    }
  }, [_c('h5', {
    staticClass: "ht5"
  }, [_vm._v("审核意见：")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudAppInspect.inspectComment),
      expression: "tCloudAppInspect.inspectComment"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "rows": "8",
      "id": "myArea",
      "maxlength": "250"
    },
    domProps: {
      "value": (_vm.tCloudAppInspect.inspectComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudAppInspect, "inspectComment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn_box text-center partition_message"
  }, [_c('span', {
    staticClass: "btn btn_submit",
    attrs: {
      "id": "review_yes"
    },
    on: {
      "click": function($event) {
        return _vm.doSubmit(1)
      }
    }
  }, [_vm._v("审核通过")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn_submit",
    attrs: {
      "id": "review_no"
    },
    on: {
      "click": function($event) {
        return _vm.doSubmit(2)
      }
    }
  }, [_vm._v("审核不通过")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "line_block"
  }, [_c('h5', {
    staticClass: "ht5"
  }, [_vm._v("历史版本：")]), _vm._v(" "), _c('a', {
    staticClass: "cursor verson",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("查看历史版本")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t应用名称\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t应用版本\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t发布时间\n\t\t\t\t\t\t\t")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-7ea30643"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/review_app.vue
// module id = 1270
// module chunks = 1